<template>
  <div id="app">
    <BoutList />
  </div>
</template>

<script>
import BoutList from './components/BoutList.vue'

export default {
  name: 'app',
  components: {
    BoutList
  }
}
</script>

